// V1.58 · Profesor por defecto: José Alfredo (fuente única para calendario y citas)
const norm = (s) =>
  (s || "").toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export const isJoseAlfredo = (t) => {
  const s = norm(`${t?.label || ""} ${t?.name || ""} ${t?.code || ""}`);
  return s.includes("jose alfredo") || s.includes("josealfredo");
};

export const preferJoseAlfredo = (list = []) =>
  [...list].sort((a, b) => (isJoseAlfredo(b) ? 1 : 0) - (isJoseAlfredo(a) ? 1 : 0));
